import { DataCollectionResource } from 'types';

export const DataProjectId = {
    GBD: 1,
    COVID19: 2,
    COMORBIDITY_STUDY: 3,
    LUNG_CANCER: 5,
    EDP: 6,
    COVID19_US_COUNTIES: 7,
    RACE_ETHNICITY: 8,
    AMR: 9,
    GBD2020: 10,
    SIMULATION: 11,
    GBD2020_CVD: 12,
    HEALTH_THREAT_METRICS: 13,
    DENGUE_SCENARIOS: 15,
    POPULATION_FORECAST: 16,
    EXPENDITURE: 18,
};

export const DATA_PROJECTS_WITH_ALL_DATA_TYPES_OPTION = [
    DataProjectId.GBD,
    DataProjectId.LUNG_CANCER,
    DataProjectId.RACE_ETHNICITY,
];

export const isDataToolAccessible = (
    dataProjectIds: null | number[],
    dataCollections: null | DataCollectionResource[]
): boolean =>
    !!(
        dataCollections &&
        dataCollections.length &&
        dataProjectIds &&
        dataCollections.find((collection) => dataProjectIds.includes(collection.data_project_id))
    );
